export default {
  spreadsheetTips: 'Dicas de planilha',
  tip1: 'Os dados podem ser selecionados e copiados de/para qualquer software de planilha',
  tip2: 'Os valores modificados pelo usuário são mostrados usando',
  thisColor: 'esta cor',
  tip3: 'Ao excluir o valor de uma célula, ela voltará ao seu valor padrão',
  tip4: 'Depois de inserir dados em uma célula, você pode pressionar Enter para descer ou Tab para ir para a direita',
  close: 'Fechar',
  period: 'Período',
  valueVariousUnits: 'Valor (várias unidades)',
  externalVariables: 'Variáveis externas',
  series: 'Séries'
}
